import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { activeTab: { type: String, default: "connections" } }

  connect() {
    // Check URL param or hash for tab
    const params = new URLSearchParams(window.location.search)
    const tabParam = params.get("tab")
    const hash = window.location.hash.replace("#", "")
    const requested = tabParam || hash
    if (requested && this.panelTargets.some(p => p.dataset.tab === requested)) {
      this.activeTabValue = requested
    }
    this.showTab()
  }

  switchTab(event) {
    event.preventDefault()
    this.activeTabValue = event.currentTarget.dataset.tab
    window.location.hash = this.activeTabValue
    this.showTab()
  }

  showTab() {
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tab === this.activeTabValue
      tab.classList.toggle("bg-white", active)
      tab.classList.toggle("text-fg", active)
      tab.classList.toggle("shadow-sm", active)
      tab.classList.toggle("text-fg-muted", !active)
    })
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== this.activeTabValue)
    })
  }

  clearMask(event) {
    if (event.target.value === "••••••••") {
      event.target.value = ""
    }
  }

  confirmNsfw(event) {
    const checkbox = event.target
    if (checkbox.checked) {
      const confirmed = confirm(
        "Age Verification\n\nBy enabling NSFW content, you confirm that you are at least 18 years old and legally permitted to view adult content in your jurisdiction.\n\nDo you confirm?"
      )
      if (!confirmed) {
        checkbox.checked = false
      }
    }
  }

  toggleProvider(event) {
    const labels = event.target.closest('.flex').querySelectorAll('label')
    labels.forEach(label => {
      const radio = label.querySelector('input[type="radio"]')
      const active = radio.checked
      label.classList.toggle('border-accent', active)
      label.classList.toggle('bg-accent/5', active)
      label.classList.toggle('text-fg', active)
      label.classList.toggle('border-border-lt', !active)
      label.classList.toggle('text-fg-muted', !active)
    })
  }
}
